import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

const SelfDirectedFooter = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  return (
    <Box
      pad={isMobile ? { horizontal: 'spacing16', bottom: 'spacing24' } : { bottom: 'spacing24' }}
      direction="column"
      margin={isMobile ? { top: 'spacing12' } : { top: 'spacing24' }}
    >
      <Box
        pad={{ vertical: 'spacing16' }}
        border={{ side: 'horizontal', color: 'border1' }}
        data-testid="sell-investments_disclosure"
      >
        <Text weight={700}>{t('Disclosure')}</Text>
        <Text margin={{ top: 'spacing12' }} color="textSecondary" weight={400} style={{ maxWidth: '100%' }}>
          {t(
            'Trades will be submitted today. Trade settlement may take up to 3 days. If the market is not open at the time of trade submission, it will be executed at the next market open. Going forward, all trades will be automatically submitted on future investment account contributions and rebalancing of the holdings to the recommended portfolio allocation.'
          )}
        </Text>
      </Box>
      <Box pad={{ top: 'spacing16' }}>
        <Text color="textSecondary" weight={400} style={{ maxWidth: '100%' }}>
          {t(
            'Investment advisory services offered through Intellicents investment solutions, inc., an SEC registered investment adviser.'
          )}
        </Text>
      </Box>
    </Box>
  );
};

export default SelfDirectedFooter;
